import { Controller } from '@hotwired/stimulus'
import { Popover } from 'bootstrap'

export default class extends Controller {
  static values = {
    title: String,
    content: String,
    placement: { type: String, default: 'top' }
  }

  connect() {
    this.popover = new Popover(this.element, {
      title: this.titleValue,
      content: this.contentValue,
      placement: this.placementValue,
      trigger: 'hover focus',
      customClass: 'tooltip-popover-pop'
    })
  }

  disconnect() {
    this.popover?.dispose()
    this.popover = null
  }
}
